import { useMutation } from '@apollo/client';

import { SAVE_REQUESTS_BATCH } from '../queries/SaveRequestsBatchMutation';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useSaveRequestsBatchMutation = (options: any = {}) => useMutation(SAVE_REQUESTS_BATCH, { //
  ...options,
});
